import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import directives from './directives'
import './assets/css/common.css'; // 引入全局样式
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { imagePath } from '@/utils/imagePath'
// import { createHead } from '@vueuse/head'
import { createMetaManager } from 'vue-meta';

const app = createApp(App)
const metaManager = createMetaManager();

// 环境判断
const isLocal = window.location.origin.includes('partyke.cn:5173');
const isProduction = window.location.origin.includes('gw.930pm.cn');

// 设置全局变量
app.config.globalProperties.$isLocal = isLocal;
app.config.globalProperties.$isProduction = isProduction;

app.config.globalProperties.$imagePath = imagePath;

app.use(metaManager)
app.use(router)
app.use(ElementPlus)
app.use(directives)

app.mount('#app')
